import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-none" }
const _hoisted_2 = {
  key: 0,
  style: {"word-break":"break-word"}
}
const _hoisted_3 = { key: 0 }

import {MyTooltip} from "~/core-ui/vue/ui/my-tooltip/MyTooltip";
import {computed} from "vue";


const __default__ = {
    name: "MyTooltipSingleton"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let visible = computed(() => {
    return MyTooltip.visible && (!!MyTooltip.options?.text || !!MyTooltip.options?.component)
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, {
    ref: "tooltipRef",
    visible: _unref(visible),
    disabled: !_unref(visible),
    "popper-class": {
            'd-none': !_unref(visible)
        },
    "popper-options": {
          modifiers: [
            {
              name: 'computeStyles',
              options: {
                adaptive: false,
                enabled: false
              }
            }
          ]
        },
    "virtual-ref": _unref(MyTooltip).virtualRef,
    "virtual-triggering": "",
    placement: _unref(MyTooltip).options?.placement
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(MyTooltip).visible) + " " + _toDisplayString(!!_unref(MyTooltip).options?.text) + " " + _toDisplayString(!!_unref(MyTooltip).options?.component), 1),
      (_unref(MyTooltip).options?.text)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MyTooltip).options.text.split('\n'), (line, key) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (key > 0)
                  ? (_openBlock(), _createElementBlock("br", _hoisted_3))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(line), 1)
              ], 64))
            }), 256))
          ]))
        : (_unref(MyTooltip).options?.component)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(MyTooltip).options.component), _normalizeProps(_mergeProps({ key: 1 }, _unref(MyTooltip).options.props ?? {})), null, 16))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "disabled", "popper-class", "virtual-ref", "placement"]))
}
}

})